import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { normalizePhone } from "src/libs/portal/season/contact-detail-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  height: 100%;
}

.profile-page {
  background: radial-gradient(circle at 13% 0%, rgba(16, 185, 129, 0.08), transparent 28rem), radial-gradient(circle at 92% 8%, rgba(59, 130, 246, 0.05), transparent 24rem), linear-gradient(180deg, #f8fbf9 0%, #f5f8f6 100%);
  min-height: 100%;
}

.profile-main {
  min-height: calc(100vh - 5rem);
}

.profile-workspace {
  animation: profile-enter 260ms ease-out;
  padding-bottom: 2rem;
}

.profile-hero {
  background: linear-gradient(112deg, #064e3b 0%, #065f46 56%, #047857 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 1.15rem;
  box-shadow: 0 20px 46px rgba(6, 78, 59, 0.18);
  color: #ffffff;
  overflow: hidden;
  padding: 1.45rem 1.6rem;
  position: relative;
}

.profile-hero-glow {
  background: rgba(110, 231, 183, 0.14);
  border-radius: 9999px;
  height: 15rem;
  position: absolute;
  right: -4rem;
  top: -9rem;
  width: 15rem;
}

.profile-hero-content {
  align-items: center;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.profile-avatar {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.23);
  border-radius: 1rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14);
  display: flex;
  flex-shrink: 0;
  font-size: 1.25rem;
  font-weight: 800;
  height: 4rem;
  justify-content: center;
  width: 4rem;
}

.profile-kicker {
  color: #a7f3d0;
  font-size: 0.5625rem;
  font-weight: 850;
  letter-spacing: 0.15em;
  margin-bottom: 0.25rem;
}

.profile-title {
  font-size: 1.25rem;
  font-weight: 750;
  letter-spacing: -0.035em;
}

.profile-copy {
  color: rgba(236, 253, 245, 0.72);
  font-size: 0.6875rem;
  margin-top: 0.3rem;
}

.profile-hero-meta {
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 0.85rem;
  display: flex;
  gap: 1rem;
  min-width: 18rem;
  padding: 0.75rem 0.85rem;
}

.profile-meta-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.profile-meta-label {
  color: rgba(209, 250, 229, 0.6);
  font-size: 0.5rem;
  font-weight: 850;
  letter-spacing: 0.13em;
}

.profile-meta-value {
  font-size: 0.6875rem;
  font-weight: 650;
  margin-top: 0.15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-role-chip {
  background: #ffffff;
  border-radius: 9999px;
  color: #065f46;
  font-size: 0.625rem;
  font-weight: 850;
  padding: 0.35rem 0.65rem;
}

.profile-card {
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(203, 213, 225, 0.76);
  border-radius: 1rem;
  box-shadow: 0 15px 34px rgba(15, 23, 42, 0.055);
  overflow: hidden;
}

.profile-card-header {
  align-items: center;
  background: linear-gradient(180deg, #ffffff, #fbfdfc);
  border-bottom: 1px solid #e5ece8;
  display: flex;
  min-height: 4.8rem;
  padding: 0.95rem 1.1rem;
}

.profile-card-icon {
  align-items: center;
  background: linear-gradient(145deg, #ecfdf5, #d1fae5);
  border: 1px solid #a7f3d0;
  border-radius: 0.75rem;
  color: #047857;
  display: flex;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.profile-card-icon.is-security {
  background: linear-gradient(145deg, #eff6ff, #dbeafe);
  border-color: #bfdbfe;
  color: #2563eb;
}

.profile-card-title {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 750;
  letter-spacing: -0.025em;
}

.profile-card-description {
  color: #64748b;
  font-size: 0.6875rem;
  margin-top: 0.2rem;
}

.profile-summary-card {
  background: radial-gradient(circle at 100% 0%, rgba(16, 185, 129, 0.09), transparent 8rem), #f8fbf9;
  border: 1px solid #dfe9e4;
  border-radius: 0.8rem;
}

.profile-input {
  background: #ffffff;
  border: 1px solid #d5dee8;
  border-radius: 0.625rem;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.025);
}

.profile-input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12);
}

.profile-input:disabled {
  background: #f4f7f5;
  color: #94a3b8;
}

.profile-card-footer {
  align-items: center;
  background: #fbfdfc;
  border-top: 1px solid #e5ece8;
  display: flex;
  justify-content: flex-end;
  min-height: 4rem;
  padding: 0.75rem 1rem;
}

.profile-primary-button {
  align-items: center;
  background: linear-gradient(135deg, #065f46, #047857);
  border-radius: 0.65rem;
  box-shadow: 0 7px 15px rgba(6, 78, 59, 0.16);
  color: #ffffff;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 750;
  height: 2.35rem;
  padding: 0 0.95rem;
  transition: box-shadow 160ms ease, transform 160ms ease;
}

.profile-primary-button:hover {
  box-shadow: 0 10px 20px rgba(6, 78, 59, 0.22);
  transform: translateY(-1px);
}

.profile-primary-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.import-card > div:first-child {
  background: linear-gradient(180deg, #fffdf7, #ffffff);
}

.import-card input,
.import-card select {
  border-radius: 0.625rem;
}

.import-analysis-shell {
  background: #ffffff;
}

.import-stepper {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.import-step {
  align-items: center;
  appearance: none;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 0.65rem;
  min-height: 3.4rem;
  padding: 0.65rem 0.75rem;
  text-align: left;
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
  width: 100%;
}

.import-step:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.import-step:focus-visible {
  outline: 3px solid rgba(16, 185, 129, 0.2);
  outline-offset: 2px;
}

.import-step.is-active {
  border-color: #059669;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.16);
}

.import-step > span {
  align-items: center;
  background: #e2e8f0;
  border-radius: 9999px;
  color: #475569;
  display: flex;
  flex-shrink: 0;
  font-size: 0.6875rem;
  font-weight: 800;
  height: 1.65rem;
  justify-content: center;
  width: 1.65rem;
}

.import-step strong,
.import-step small {
  display: block;
}

.import-step strong {
  color: #334155;
  font-size: 0.75rem;
  font-weight: 750;
}

.import-step small {
  color: #94a3b8;
  font-size: 0.625rem;
  margin-top: 0.1rem;
}

.import-step.is-complete {
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.import-step.is-complete > span {
  background: #047857;
  color: #ffffff;
}

.import-step.is-complete strong {
  color: #065f46;
}

.import-step.is-complete small {
  color: #047857;
}

.import-workflow-nav {
  align-items: center;
  background: #f0fdf4;
  border: 1px solid #a7f3d0;
  border-radius: 0.75rem;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin: 0 1rem 1rem;
  padding: 0.85rem 1rem;
}

.import-analysis-tabs {
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 0.25rem;
  overflow-x: auto;
}

.import-analysis-tab {
  align-items: center;
  border-bottom: 2px solid transparent;
  color: #64748b;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 0.4rem;
  min-height: 2.8rem;
  padding: 0 0.75rem;
}

.import-analysis-tab span {
  background: #f1f5f9;
  border-radius: 9999px;
  color: #64748b;
  font-size: 0.625rem;
  padding: 0.1rem 0.4rem;
}

.import-analysis-tab.is-active {
  border-bottom-color: #047857;
  color: #065f46;
}

.import-analysis-tab.is-active span {
  background: #d1fae5;
  color: #065f46;
}

.import-analysis-panel {
  padding: 1rem;
}

.import-summary-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.85rem;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.035);
  min-height: 8.5rem;
  padding: 1rem;
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.import-summary-card:hover {
  border-color: #6ee7b7;
  box-shadow: 0 10px 24px rgba(6, 78, 59, 0.08);
  transform: translateY(-1px);
}

.import-filter-button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 9999px;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
  min-height: 2rem;
  padding: 0.3rem 0.7rem;
}

.import-filter-button.is-active {
  background: #065f46;
  border-color: #065f46;
  color: #ffffff;
}

.import-analysis-table-shell.is-cases {
  min-height: 52rem;
}

.import-analysis-table-shell.is-customers {
  min-height: 38rem;
}

.import-analysis-table-shell tbody tr {
  height: 3.5rem;
}

.import-pagination {
  align-items: center;
  color: #64748b;
  display: grid;
  font-size: 0.6875rem;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  min-height: 2.4rem;
}

.import-pagination > span {
  grid-column: 1;
  justify-self: start;
}

.import-pagination > div {
  display: flex;
  gap: 0.4rem;
  grid-column: 2;
  justify-self: center;
}

.import-pagination button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 700;
  min-width: 3.5rem;
  padding: 0.4rem 0.65rem;
}

.import-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

@keyframes profile-enter {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 767px) {
  .profile-main {
    padding-left: 0.85rem !important;
    padding-right: 0.85rem !important;
  }
  .profile-hero {
    border-radius: 1rem;
    padding: 1.2rem;
  }
  .profile-hero-content {
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
  }
  .profile-hero-meta {
    min-width: 0;
    width: 100%;
  }
  .import-stepper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .import-step {
    min-height: 3rem;
    padding: 0.55rem;
  }
  .import-analysis-panel {
    padding: 0.85rem;
  }
  .import-workflow-nav {
    align-items: stretch;
    flex-direction: column;
    margin-left: 0.85rem;
    margin-right: 0.85rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .profile-workspace {
    animation: none;
  }
  .profile-primary-button {
    transition: none;
  }
  .profile-primary-button:hover {
    transform: none;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;
    public passwordChangeNoticeShown: boolean = false;

    public importAccessChecked: boolean = false;
    public canImport: boolean = false;
    public selectedImportFile: any = null;
    public importJobs: any[] = [];
    public importResult: any = null;
    public importing: boolean = false;
    public importProgress: number = 0;
    public approvalSavingKey: string = '';
    public grantSaving: boolean = false;
    public executingImport: boolean = false;
    public executionRequestKey: string = '';
    public downloadingReport: string = '';
    public undoGrantSaving: boolean = false;
    public undoingImport: boolean = false;
    public undoRequestKey: string = '';
    public undoConfirmation: string = '';
    public importTab: string = 'summary';
    public importWorkflowStep: number = 1;
    public importCaseSearch: string = '';
    public importCaseFilter: string = 'ALL';
    public importCasePage: number = 1;
    public importCasePageSize: number = 15;
    public importCustomerSearch: string = '';
    public importCustomerFilter: string = 'ALL';
    public importCustomerPage: number = 1;
    public importCustomerPageSize: number = 15;
    public statusMappingSearch: string = '';
    public statusMappingFilter: string = 'PENDING';
    public statusMappingPage: number = 1;
    public statusMappingPageSize: number = 10;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.loadImportJobs();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
        }
        await this.service.render();
        if (this.user?.must_change_password && !this.passwordChangeNoticeShown) {
            this.passwordChangeNoticeShown = true;
            await this.service.modal.show({
                title: '비밀번호 변경 필요',
                message: '비밀번호를 변경하세요. 기본 비밀번호로는 다른 업무 화면을 사용할 수 없습니다.',
                action: '비밀번호 변경하기',
                cancel: false,
                status: 'warning',
                actionBtn: 'warning'
            });
        }
    }

    public get profileInputsValid(): boolean {
        const name = String(this.user?.name || '').trim();
        return name.length > 0 && [...name].length <= 50 && normalizePhone(this.user?.mobile, true) !== null;
    }

    public async updateProfile() {
        if (this.saving) return;
        if (!this.profileInputsValid) {
            await this.service.modal.error('이름은 1~50자, 휴대전화는 010-1234-5678 형식으로 입력해 주세요.');
            return;
        }
        const name = String(this.user.name).trim();
        const mobile = normalizePhone(this.user.mobile, true) || '';
        this.saving = true;
        try {
            await this.service.render();
            const {code, data} = await wiz.call('update_profile', {name, mobile});
            if (code === 200) {
                this.user.name = name;
                this.user.mobile = mobile;
                await this.service.modal.success('프로필이 업데이트되었습니다.');
            } else {
                await this.service.modal.error(data || '업데이트에 실패했습니다.');
            }
        } catch (error) {
            await this.service.modal.error('프로필 저장 중 연결이 원활하지 않습니다. 입력값을 확인한 후 다시 시도해 주세요.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async changePassword() {
        if (this.changingPassword) return;
        const {current_password, new_password, confirm_password} = this.passwordForm;
        const bytes = (value: string) => new TextEncoder().encode(value || '').length;
        if (!current_password || bytes(current_password) > 72) {
            await this.service.modal.error('현재 비밀번호를 UTF-8 72바이트 이하로 입력해 주세요.');
            return;
        }
        if (!new_password?.trim() || [...new_password].length < 8 || bytes(new_password) > 72) {
            await this.service.modal.error('새 비밀번호는 8자 이상, UTF-8 72바이트 이하로 입력해 주세요.');
            return;
        }
        if (new_password === current_password || new_password === '1234') {
            await this.service.modal.error('기본 비밀번호와 다른 새 비밀번호를 입력해 주세요.');
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error('새 비밀번호가 일치하지 않습니다.');
            return;
        }
        this.changingPassword = true;
        let changed = false;
        try {
            await this.service.render();
            const {code, data} = await wiz.call('change_password', {current_password, new_password});
            if (code === 200) {
                changed = true;
                this.passwordForm = {current_password: '', new_password: '', confirm_password: ''};
                if (this.user) this.user.must_change_password = false;
                if (this.service.auth.session) this.service.auth.session.must_change_password = false;
                await this.service.modal.success('비밀번호가 변경되었습니다.');
            } else {
                await this.service.modal.error(data || '비밀번호 변경에 실패했습니다.');
            }
        } catch (error) {
            await this.service.modal.error('비밀번호 변경 요청의 결과를 확인할 수 없습니다. 다시 로그인하여 확인해 주세요.');
        } finally {
            this.changingPassword = false;
            await this.service.render();
        }
        if (changed) await this.loadImportJobs();
    }

    public async loadImportJobs() {
        if (this.user?.must_change_password) {
            this.importAccessChecked = true;
            this.canImport = false;
            await this.service.render();
            return;
        }
        const response: any = await wiz.call("list_import_jobs");
        const payload = this.responsePayload(response);
        this.importAccessChecked = true;
        if (Number(payload.code) === 200) {
            this.canImport = true;
            this.importJobs = payload.data?.jobs || [];
            const latestJobId = this.importJobs?.[0]?.id || '';
            if (!this.importResult && latestJobId) {
                await this.loadImportJob(latestJobId);
            }
        } else {
            this.canImport = false;
            this.importJobs = [];
        }
        await this.service.render();
    }

    public async selectImportFile(event: any) {
        const file = event?.target?.files?.[0] || null;
        if (event?.target) event.target.value = '';
        if (!file || this.importing) return;
        const extension = String(file.name || '').toLowerCase().split('.').pop();
        if (!['xls', 'xlsx'].includes(extension)) {
            await this.service.modal.error('XLS 또는 XLSX 파일만 선택해 주세요.');
            return;
        }
        if (!Number.isSafeInteger(file.size) || file.size <= 0 || file.size > 20 * 1024 * 1024) {
            await this.service.modal.error('Excel 파일은 1바이트 이상 20MB 이하만 업로드할 수 있습니다.');
            return;
        }
        this.selectedImportFile = file;
        this.importProgress = 0;
        await this.service.render();
    }

    public async runImportDryRun() {
        if (!this.selectedImportFile || this.importing) {
            if (!this.selectedImportFile) {
                await this.service.modal.error("dry-run할 Excel 파일을 선택해주세요.");
            }
            return;
        }

        this.importing = true;
        this.importProgress = 0;
        await this.service.render();

        const formData = new FormData();
        formData.append('file', this.selectedImportFile);
        const response: any = await this.service.file.upload(
            wiz.url("create_import_job"),
            formData,
            async (percent: number) => {
                this.importProgress = percent;
                await this.service.render();
            }
        );
        const payload = this.responsePayload(response);
        this.importing = false;

        if (Number(payload.code) === 200 && payload.data) {
            this.importResult = payload.data;
            this.importProgress = 100;
            await this.loadImportJobs();
            await this.loadImportJob(payload.data.job?.id);
            await this.service.modal.success(
                payload.data.reused
                    ? "동일 파일의 기존 dry-run 결과를 불러왔습니다."
                    : "Excel dry-run이 완료되었습니다. 실제 업무 데이터는 저장하지 않았습니다."
            );
        } else {
            this.importProgress = 0;
            await this.service.modal.error(this.responseMessage(payload, "Excel dry-run에 실패했습니다."));
        }
        await this.service.render();
    }

    public async loadImportJob(jobId: string) {
        if (!jobId) return;
        const previousJobId = this.importResult?.job?.id || '';
        const response: any = await wiz.call("get_import_job", { job_id: jobId });
        const payload = this.responsePayload(response);
        if (Number(payload.code) === 200 && payload.data) {
            this.importResult = payload.data;
            if (previousJobId !== payload.data.job?.id) {
                this.executionRequestKey = '';
                this.undoRequestKey = '';
                this.undoConfirmation = '';
                this.importTab = 'summary';
                this.importWorkflowStep = 1;
                this.importCasePage = 1;
                this.importCustomerPage = 1;
                this.statusMappingPage = 1;
            }
            if (this.importTab === 'execution' && payload.data.execution?.executed) {
                this.importWorkflowStep = 4;
            }
            this.prepareApprovalDrafts();
        } else {
            await this.service.modal.error(this.responseMessage(payload, "import job을 불러오지 못했습니다."));
        }
        await this.service.render();
    }

    public async approveStatusMapping(item: any) {
        if (!this.importResult?.job?.id || !item?.draft_status) return;
        const key = `STATUS:${item.source_value}`;
        await this.saveImportApproval(
            key,
            'approve_import_status_mapping',
            {
                job_id: this.importResult.job.id,
                source_value: item.source_value || '',
                canonical_status: item.draft_status
            },
            '상태 매핑을 승인했습니다.'
        );
    }

    public recommendedApprovalPlan() {
        const approvals = this.importResult?.approvals || {};
        const statusItems = (approvals.status_mappings || []).filter(
            (item: any) => item?.approval_status !== 'APPROVED'
        );
        const ourRefItems = (approvals.our_ref_items || []).filter(
            (item: any) => item?.approval_status !== 'APPROVED'
        );
        const fieldItems = (approvals.field_update_items || []).filter(
            (item: any) => item?.approval_status !== 'APPROVED'
        );
        return {
            total: statusItems.length + ourRefItems.length + fieldItems.length,
            status_count: statusItems.length,
            status_rows: statusItems.reduce(
                (total: number, item: any) => total + Number(item?.row_count || 0),
                0
            ),
            unknown_status_count: statusItems.filter(
                (item: any) => String(
                    item?.recommended_status || ''
                ).toUpperCase() === 'UNKNOWN'
            ).length,
            our_ref_count: ourRefItems.length,
            field_update_count: fieldItems.length
        };
    }

    public recommendedApprovalCount() {
        return this.recommendedApprovalPlan().total;
    }

    public manualApprovalCount() {
        return this.pendingDuplicateItems().length;
    }

    public pendingDuplicateItems() {
        return (this.importResult?.approvals?.duplicate_items || []).filter(
            (item: any) => item?.approval_status !== 'APPROVED'
        );
    }

    public completedDuplicateItems() {
        return (this.importResult?.approvals?.duplicate_items || []).filter(
            (item: any) => item?.approval_status === 'APPROVED'
        );
    }

    public pendingFieldUpdateItems() {
        return (this.importResult?.approvals?.field_update_items || []).filter(
            (item: any) => item?.approval_status !== 'APPROVED'
        );
    }

    public async applyRecommendedApprovals() {
        const jobId = this.importResult?.job?.id || '';
        const count = this.recommendedApprovalCount();
        if (!jobId || !count || this.approvalSavingKey) return;

        this.approvalSavingKey = 'RECOMMENDED_ALL';
        await this.service.render();
        const response: any = await wiz.call(
            'apply_import_recommended_approvals',
            {
                payload: JSON.stringify({ job_id: jobId })
            }
        );
        const result = this.responsePayload(response);
        this.approvalSavingKey = '';
        if (Number(result.code) === 200) {
            const appliedCount = Number(
                result?.data?.applied?.total || count
            );
            await this.loadImportJob(jobId);
            await this.service.modal.success(
                `${appliedCount}개 항목을 권장 방식으로 처리했습니다.`
            );
        } else {
            await this.service.modal.error(
                this.responseMessage(result, '권장 처리 저장에 실패했습니다.')
            );
        }
        await this.service.render();
    }

    public async approveDuplicate(item: any) {
        if (!item?.draft_representative_row_id) return;
        await this.saveImportApproval(
            `DUPLICATE:${item.subject_key}`,
            'approve_import_decision',
            {
                job_id: this.importResult.job.id,
                approval_type: 'DUPLICATE',
                subject_key: item.subject_key,
                decision: { representative_row_id: item.draft_representative_row_id }
            },
            '중복 대표행을 승인했습니다.'
        );
    }

    public async approveDuplicateRow(item: any, rowId: string) {
        if (!rowId || this.approvalSavingKey) return;
        item.draft_representative_row_id = rowId;
        await this.approveDuplicate(item);
    }

    public async approveOurRef(item: any) {
        await this.saveImportApproval(
            `OUR_REF:${item.subject_key}`,
            'approve_import_decision',
            {
                job_id: this.importResult.job.id,
                approval_type: 'OUR_REF',
                subject_key: item.subject_key,
                decision: { action: item.suggested_action }
            },
            `Excel ${item?.source_row || ''}행의 연결 방법을 저장했습니다.`
        );
    }

    public pendingOurRefItems() {
        return (this.importResult?.approvals?.our_ref_items || []).filter(
            (item: any) => item?.approval_status !== 'APPROVED'
        );
    }

    public completedOurRefItems() {
        return (this.importResult?.approvals?.our_ref_items || []).filter(
            (item: any) => item?.approval_status === 'APPROVED'
        );
    }

    public ourRefSourceCase(item: any) {
        const source = item?.source_case || {};
        if (source?.title || source?.application_no || source?.customers?.length) {
            return source;
        }
        const caseRow = (this.importResult?.analysis?.cases || []).find(
            (candidate: any) => Number(candidate?.row_number || 0) === Number(item?.source_row || 0)
        ) || {};
        return {
            title: caseRow.title || '',
            application_no: caseRow.application_no || '',
            customers: caseRow.customer_candidates || []
        };
    }

    public ourRefMatchTitle(match: any) {
        return match?.title || '(사건명 없음)';
    }

    public ourRefMatchCollectionLabel(matches: any[]) {
        const values = matches || [];
        if (values.length === 1) return this.ourRefMatchTitle(values[0]);
        if (values.length > 1) return `${values.length}개 기존 사건`;
        return '다른 기존 사건';
    }

    public ourRefOutcomeDescription(item: any) {
        if (item?.suggested_action === 'KEEP_STRONG') {
            const connected = this.ourRefMatchCollectionLabel(item?.application_matches);
            const unchanged = this.ourRefMatchCollectionLabel(item?.reference_matches);
            return `추천대로 처리하면 Excel 내용은 ‘${connected}’에 연결되고, ‘${unchanged}’은 변경되지 않습니다.`;
        }
        return '추천대로 처리하면 내부 관리번호만으로 기존 사건에 자동 연결하지 않습니다. 표시된 기존 사건들은 변경되지 않습니다.';
    }

    public ourRefDecisionButton(item: any) {
        return item?.suggested_action === 'KEEP_STRONG'
            ? '추천대로 연결'
            : '자동 연결하지 않고 계속';
    }

    public ourRefCompletedPrimary(item: any) {
        if (item?.suggested_action !== 'KEEP_STRONG') {
            return '기존 사건에 자동 연결하지 않음';
        }
        return `‘${this.ourRefMatchCollectionLabel(item?.application_matches)}’에 연결`;
    }

    public ourRefCompletedSecondary(item: any) {
        const unchanged = this.ourRefMatchCollectionLabel(item?.reference_matches);
        return `‘${unchanged}’은 변경하지 않음`;
    }

    public async approveFieldUpdate(item: any) {
        if (!item?.draft_action) return;
        await this.saveImportApproval(
            `FIELD_UPDATE:${item.subject_key}`,
            'approve_import_decision',
            {
                job_id: this.importResult.job.id,
                approval_type: 'FIELD_UPDATE',
                subject_key: item.subject_key,
                decision: { action: item.draft_action }
            },
            '적용할 값을 저장했습니다.'
        );
    }

    public setFieldUpdateAction(item: any, action: string) {
        if (!item || !['KEEP_EXISTING', 'USE_IMPORT'].includes(action)) return;
        item.draft_action = action;
    }

    public fieldUpdateGroups() {
        const items = this.importResult?.approvals?.field_update_items || [];
        const cases = this.importResult?.analysis?.cases || [];
        const groups: any[] = [];
        const byRow: any = {};

        for (const item of items) {
            const rowNumber = Number(item?.source_row || 0);
            const key = String(item?.row_id || rowNumber);
            if (!byRow[key]) {
                const caseRow = cases.find(
                    (candidate: any) => Number(candidate?.row_number || 0) === rowNumber
                ) || {};
                byRow[key] = {
                    row_id: item?.row_id || '',
                    source_row: rowNumber,
                    title: caseRow.title || '(사건명 없음)',
                    application_no: caseRow.application_no || '출원번호 없음',
                    customer_candidates: caseRow.customer_candidates || [],
                    items: []
                };
                groups.push(byRow[key]);
            }
            byRow[key].items.push(item);
        }

        for (const group of groups) {
            group.items.sort((left: any, right: any) => (
                Number(left?.approval_status === 'APPROVED')
                - Number(right?.approval_status === 'APPROVED')
            ));
            group.pending_count = group.items.filter(
                (item: any) => item?.approval_status !== 'APPROVED'
            ).length;
        }

        return groups.sort((left: any, right: any) => (
            Number(left.pending_count === 0) - Number(right.pending_count === 0)
            || Number(left.source_row || 0) - Number(right.source_row || 0)
        ));
    }

    public fieldUpdateLabel(field: string) {
        const labels: any = {
            'ip_right.title_ko': '국문 사건명',
            'ip_right.title_en': '영문 사건명',
            'ip_right.registration_no': '등록번호',
            'ip_right.registration_date': '등록일',
            'ip_right.status': '사건 상태',
            'matter.applicant_name': '출원인',
            'matter.registration_owner': '등록권리자',
            'matter.inventor_name': '발명자'
        };
        return labels[field] || '사건 정보';
    }

    public fieldUpdateQuestion(item: any) {
        return `${this.fieldUpdateLabel(item?.field)}를 어떤 값으로 저장할까요?`;
    }

    public fieldUpdateDifferenceDescription(item: any) {
        const label = this.fieldUpdateLabel(item?.field);
        return `현재 시스템의 ${label}와 Excel ${item?.source_row || ''}행에 적힌 ${label}가 서로 다릅니다.`;
    }

    public fieldUpdateChoiceTitle(item: any, action: string) {
        const label = this.fieldUpdateLabel(item?.field);
        return action === 'USE_IMPORT'
            ? `Excel ${item?.source_row || ''}행의 ${label}`
            : `현재 시스템의 ${label}`;
    }

    public fieldUpdateChoiceDescription(item: any, action: string) {
        const label = this.fieldUpdateLabel(item?.field);
        return action === 'USE_IMPORT'
            ? `선택하면 실제 이관 시 ${label}를 이 Excel 값으로 변경합니다.`
            : `선택하면 기존 사건의 ${label}를 변경하지 않습니다.`;
    }

    public fieldUpdateSaveLabel(item: any) {
        const label = this.fieldUpdateLabel(item?.field);
        return item?.draft_action === 'USE_IMPORT'
            ? `Excel ${label}로 변경`
            : `현재 ${label} 유지`;
    }

    public fieldUpdateDisplayValue(item: any, value: any) {
        const text = String(value || '').trim();
        if (!text) return '(빈 값)';
        if (item?.field === 'ip_right.status') {
            return this.canonicalStatusLabel(text);
        }
        return text;
    }

    public blockerLabel(code: string) {
        const labels: any = {
            STATUS_MAPPING_UNAPPROVED: '미승인·매핑 불가 상태',
            OURREF_AMBIGUOUS: '출원번호와 내부 관리번호 불일치',
            DUPLICATE_REPRESENTATIVE_UNSELECTED: '대표행 미선택 중복',
            FIELD_UPDATE_UNAPPROVED: '미승인 필드 업데이트',
            EXECUTION_GRANT_REQUIRED: '실행 grant 필요',
            EXECUTION_GRANT_EXPIRED: '실행 grant 만료',
            EXECUTION_GRANT_USED: '실행 grant 사용 완료',
            EXECUTION_GRANT_REVOKED: '실행 grant 취소',
            KONE_IMPORT_FORBIDDEN: '케이원 XLS 실행 금지',
            ASSESSOR_NOT_APPROVED: '실행 직전 승인 재검증 실패',
            JOB_NOT_COMPLETED: '실행 완료 job만 Undo 가능',
            UNDO_SNAPSHOT_MISSING: 'Undo 변경 스냅샷 없음',
            CREATED_ENTITY_MISSING: 'Import 생성 데이터 누락',
            CREATED_ENTITY_OWNERSHIP_CHANGED: '생성 데이터 소유권 변경',
            CREATED_ENTITY_MODIFIED: '생성 데이터 후속 수정 감지',
            UPDATED_ENTITY_MISSING: '업데이트 대상 누락',
            UPDATED_ENTITY_MODIFIED: '업데이트 대상 후속 수정 감지',
            UPDATED_VALUE_CHANGED: '업데이트 값 후속 변경 감지',
            BEFORE_SNAPSHOT_MISSING: 'before snapshot 누락',
            ENTITY_FINGERPRINT_MISSING: '전체 행 fingerprint 누락',
            FK_DEPENDENCY_PRESENT: '후속 데이터 또는 FK 의존성 존재',
            KONE_UNDO_FORBIDDEN: '케이원 Import Undo 금지'
        };
        return labels[code] || code;
    }

    public grantStatusLabel(status: string) {
        const labels: any = {
            VALID: '유효',
            MISSING: '미발급',
            EXPIRED: '만료',
            USED: '사용 완료',
            REVOKED: '취소',
            PROTECTED: '발급 금지'
        };
        return labels[status] || status || '미발급';
    }

    public async createExecutionGrant() {
        const jobId = this.importResult?.job?.id;
        if (!jobId || this.grantSaving) return;
        this.grantSaving = true;
        await this.service.render();
        const response: any = await wiz.call("create_import_execution_grant", {
            job_id: jobId
        });
        const payload = this.responsePayload(response);
        this.grantSaving = false;
        if (Number(payload.code) === 200) {
            this.executionRequestKey = '';
            await this.loadImportJob(jobId);
            await this.service.modal.success("5분 유효 일회성 실행 grant를 발급했습니다.");
        } else {
            await this.service.modal.error(
                this.responseMessage(payload, "실행 grant 발급에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async revokeExecutionGrant() {
        const jobId = this.importResult?.job?.id;
        if (!jobId || this.grantSaving) return;
        const confirmed = await this.service.modal.show({
            title: '실행 grant 취소',
            message: '현재 job의 미사용 실행 grant를 즉시 취소합니다.',
            action: 'grant 취소',
            cancel: '돌아가기',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.grantSaving = true;
        await this.service.render();
        const response: any = await wiz.call("revoke_import_execution_grant", {
            job_id: jobId
        });
        const payload = this.responsePayload(response);
        this.grantSaving = false;
        if (Number(payload.code) === 200) {
            this.executionRequestKey = '';
            await this.loadImportJob(jobId);
            await this.service.modal.success("실행 grant를 취소했습니다.");
        } else {
            await this.service.modal.error(
                this.responseMessage(payload, "실행 grant 취소에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async executeImportJob() {
        const jobId = this.importResult?.job?.id;
        if (!jobId || this.executingImport) return;
        const confirmed = await this.service.modal.show({
            title: 'Excel Import 실제 실행',
            message: '승인 snapshot으로 현재 tenant의 고객·사건·권리에 실제 반영합니다. 일회성 grant는 성공 시 즉시 소모됩니다.',
            action: '실제 실행',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        if (!this.executionRequestKey) {
            this.executionRequestKey = 'execute-' + Date.now() + '-' + this.service.random(24);
        }
        this.executingImport = true;
        await this.service.render();
        const response: any = await wiz.call("execute_import_job", {
            job_id: jobId,
            confirm_job_id: jobId,
            idempotency_key: this.executionRequestKey
        });
        const payload = this.responsePayload(response);
        this.executingImport = false;
        if (Number(payload.code) === 200) {
            await this.loadImportJob(jobId);
            await this.loadImportJobs();
            await this.service.modal.success(
                payload.data?.idempotent
                    ? "동일 요청의 기존 실행 결과를 반환했습니다."
                    : "Excel Import 실행을 완료했습니다."
            );
        } else {
            await this.loadImportJob(jobId);
            await this.service.modal.error(
                this.responseMessage(payload, "Excel Import 실행에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async downloadImportResult(format: string) {
        const jobId = this.importResult?.job?.id;
        const normalized = String(format || '').toLowerCase();
        if (!jobId || !['csv', 'xlsx'].includes(normalized) || this.downloadingReport) return;
        this.downloadingReport = normalized;
        await this.service.render();
        const response: any = await wiz.call("download_import_result", {
            job_id: jobId,
            format: normalized
        });
        const payload = this.responsePayload(response);
        this.downloadingReport = '';
        if (Number(payload.code) === 200 && payload.data?.content_base64) {
            const binary = atob(payload.data.content_base64);
            const bytes = new Uint8Array(binary.length);
            for (let index = 0; index < binary.length; index += 1) {
                bytes[index] = binary.charCodeAt(index);
            }
            const blob = new Blob([bytes], { type: payload.data.content_type || 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = payload.data.filename || `import-result.${normalized}`;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            URL.revokeObjectURL(url);
        } else {
            await this.service.modal.error(
                this.responseMessage(payload, "Import 결과 다운로드에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async refreshUndoPreview() {
        const jobId = this.importResult?.job?.id;
        if (!jobId) return;
        const response: any = await wiz.call("preview_import_undo", { job_id: jobId });
        const payload = this.responsePayload(response);
        if (Number(payload.code) === 200 && payload.data) {
            this.importResult.undo.preview = payload.data;
        } else {
            await this.service.modal.error(
                this.responseMessage(payload, "Undo 영향 범위를 불러오지 못했습니다.")
            );
        }
        await this.service.render();
    }

    public async createUndoGrant() {
        const jobId = this.importResult?.job?.id;
        if (!jobId || this.undoGrantSaving) return;
        this.undoGrantSaving = true;
        await this.service.render();
        const response: any = await wiz.call("create_import_undo_grant", { job_id: jobId });
        const payload = this.responsePayload(response);
        this.undoGrantSaving = false;
        if (Number(payload.code) === 200) {
            this.undoRequestKey = '';
            await this.loadImportJob(jobId);
            await this.service.modal.success("5분 유효 일회성 Undo grant를 발급했습니다.");
        } else {
            await this.service.modal.error(
                this.responseMessage(payload, "Undo grant 발급에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async revokeUndoGrant() {
        const jobId = this.importResult?.job?.id;
        if (!jobId || this.undoGrantSaving) return;
        const confirmed = await this.service.modal.show({
            title: 'Undo grant 취소',
            message: '현재 job의 미사용 Undo grant를 즉시 취소합니다.',
            action: 'grant 취소',
            cancel: '돌아가기',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.undoGrantSaving = true;
        await this.service.render();
        const response: any = await wiz.call("revoke_import_undo_grant", { job_id: jobId });
        const payload = this.responsePayload(response);
        this.undoGrantSaving = false;
        if (Number(payload.code) === 200) {
            await this.loadImportJob(jobId);
            await this.service.modal.success("Undo grant를 취소했습니다.");
        } else {
            await this.service.modal.error(
                this.responseMessage(payload, "Undo grant 취소에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async executeImportUndo() {
        const jobId = this.importResult?.job?.id;
        if (!jobId || this.undoingImport) return;
        if (this.undoConfirmation !== jobId) {
            await this.service.modal.error("최종 확인란에 동일한 Import job ID를 입력해주세요.");
            return;
        }
        await this.refreshUndoPreview();
        if (!this.importResult?.undo?.preview?.can_undo) {
            await this.service.modal.error("영향 범위가 변경되어 Undo를 실행할 수 없습니다.");
            return;
        }
        const confirmed = await this.service.modal.show({
            title: 'Excel Import Undo 최종 확인',
            message: 'Import가 새로 생성한 데이터만 삭제하고, 이후 변경되지 않은 승인 필드만 before snapshot으로 복원합니다.',
            action: 'Undo 실행',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        if (!this.undoRequestKey) {
            this.undoRequestKey = 'undo-' + Date.now() + '-' + this.service.random(24);
        }
        this.undoingImport = true;
        await this.service.render();
        const response: any = await wiz.call("execute_import_undo", {
            job_id: jobId,
            confirm_job_id: jobId,
            undo_confirmation: this.undoConfirmation,
            idempotency_key: this.undoRequestKey
        });
        const payload = this.responsePayload(response);
        this.undoingImport = false;
        if (Number(payload.code) === 200) {
            await this.loadImportJob(jobId);
            await this.loadImportJobs();
            await this.service.modal.success(
                payload.data?.idempotent
                    ? "동일 요청의 기존 Undo 결과를 반환했습니다."
                    : "Excel Import Undo를 완료했습니다."
            );
        } else {
            await this.loadImportJob(jobId);
            await this.service.modal.error(
                this.responseMessage(payload, "Excel Import Undo에 실패했습니다.")
            );
        }
        await this.service.render();
    }

    public async setImportTab(tab: string) {
        this.importTab = tab || 'summary';
        if (['summary', 'cases', 'customers', 'columns'].includes(this.importTab)) {
            this.importWorkflowStep = 1;
        } else if (['review', 'advanced'].includes(this.importTab)) {
            this.importWorkflowStep = 2;
        } else if (this.importTab === 'execution') {
            this.importWorkflowStep = this.importResult?.execution?.executed ? 4 : 3;
        }
        await this.service.render();
    }

    public async setImportWorkflowStep(step: number) {
        const targetStep = Math.min(4, Math.max(1, Number(step || 1)));
        this.importWorkflowStep = targetStep;
        if (targetStep === 1) {
            this.importTab = 'summary';
        } else if (targetStep === 2) {
            this.importTab = 'review';
        } else {
            this.importTab = 'execution';
        }
        await this.service.render();
        this.scrollImportWorkflowTarget(targetStep);
    }

    public importWorkflowNextLabel() {
        if (this.importWorkflowStep === 1) return '검토 및 결정으로 이동';
        if (this.importWorkflowStep === 2) {
            return this.pendingApprovalCount() > 0
                ? '남은 검토 항목으로 이동'
                : '실행 준비로 이동';
        }
        if (this.importWorkflowStep === 3) {
            return this.importResult?.execution?.assessor_can_execute
                ? '실제 이관 단계로 이동'
                : '검토 단계로 돌아가기';
        }
        return this.importResult?.execution?.executed
            ? '이관 완료'
            : '실행 영역 확인';
    }

    public importWorkflowNextHint() {
        if (this.importWorkflowStep === 1) {
            return '분석 결과를 확인했다면 권장 처리와 직접 선택 항목을 검토하세요.';
        }
        if (this.importWorkflowStep === 2) {
            const manualCount = this.manualApprovalCount();
            const recommendedCount = this.recommendedApprovalCount();
            if (manualCount > 0 && recommendedCount > 0) {
                return `직접 선택 ${manualCount}건을 확인한 뒤, 나머지는 권장 처리 버튼 한 번으로 완료할 수 있습니다.`;
            }
            if (manualCount > 0) {
                return `내용 선택이 필요한 중복 사건 ${manualCount}건만 직접 확인해 주세요.`;
            }
            if (recommendedCount > 0) {
                return '반복 항목은 권장 처리 버튼을 한 번 누르면 모두 완료됩니다.';
            }
            return '모든 검토가 끝났습니다. 실제 이관 가능 여부와 실행 권한을 확인하세요.';
        }
        if (this.importWorkflowStep === 3) {
            return this.importResult?.execution?.assessor_can_execute
                ? '검토 조건을 모두 충족했습니다. 최종 실행 권한과 실제 이관 버튼을 확인하세요.'
                : '실행을 막는 항목이 남아 있습니다. 검토 단계에서 먼저 처리하세요.';
        }
        return this.importResult?.execution?.executed
            ? '실제 이관이 완료되었습니다. 아래 결과 보고서를 확인할 수 있습니다.'
            : '최종 실행 권한이 유효할 때만 실제 이관 버튼이 활성화됩니다.';
    }

    public async goNextImportWorkflow() {
        if (this.importWorkflowStep === 1) {
            await this.setImportWorkflowStep(2);
            return;
        }
        if (this.importWorkflowStep === 2) {
            if (this.pendingApprovalCount() > 0) {
                this.importTab = 'review';
                await this.service.render();
                this.scrollImportWorkflowTarget(2);
                return;
            }
            await this.setImportWorkflowStep(3);
            return;
        }
        if (this.importWorkflowStep === 3) {
            await this.setImportWorkflowStep(
                this.importResult?.execution?.assessor_can_execute ? 4 : 2
            );
            return;
        }
        this.scrollImportWorkflowTarget(4);
    }

    public async goPreviousImportWorkflow() {
        if (this.importWorkflowStep <= 1) return;
        await this.setImportWorkflowStep(this.importWorkflowStep - 1);
    }

    private scrollImportWorkflowTarget(step: number) {
        const targetIds: any = {
            1: 'import-analysis-summary',
            2: 'import-review-start',
            3: 'import-execution-readiness',
            4: 'import-execution-action'
        };
        const target = document.getElementById(targetIds[step]);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    public async setImportCaseFilter(filter: string) {
        this.importCaseFilter = filter || 'ALL';
        this.importCasePage = 1;
        await this.service.render();
    }

    public async resetImportCasePage() {
        this.importCasePage = 1;
        await this.service.render();
    }

    public filteredImportCases() {
        const rows = this.importResult?.analysis?.cases || [];
        const query = String(this.importCaseSearch || '').trim().toLowerCase();
        return rows.filter((item: any) => {
            if (this.importCaseFilter !== 'ALL' && item.category !== this.importCaseFilter) {
                return false;
            }
            if (!query) return true;
            const values = [
                item.row_number,
                item.title,
                item.application_no,
                item.right_type,
                item.status_raw,
                item.standard_status,
                ...(item.customer_candidates || [])
            ];
            return values.some(value => String(value || '').toLowerCase().includes(query));
        });
    }

    public pagedImportCases() {
        const rows = this.filteredImportCases();
        const start = (this.importCasePage - 1) * this.importCasePageSize;
        return rows.slice(start, start + this.importCasePageSize);
    }

    public importCasePageCount() {
        return Math.max(1, Math.ceil(this.filteredImportCases().length / this.importCasePageSize));
    }

    public async changeImportCasePage(direction: number) {
        this.importCasePage = Math.min(
            this.importCasePageCount(),
            Math.max(1, this.importCasePage + direction)
        );
        await this.service.render();
    }

    public async setImportCustomerFilter(filter: string) {
        this.importCustomerFilter = filter || 'ALL';
        this.importCustomerPage = 1;
        await this.service.render();
    }

    public async resetImportCustomerPage() {
        this.importCustomerPage = 1;
        await this.service.render();
    }

    public filteredImportCustomers() {
        const rows = this.importResult?.analysis?.customers || [];
        const query = String(this.importCustomerSearch || '').trim().toLowerCase();
        return rows.filter((item: any) => {
            if (this.importCustomerFilter === 'REVIEW' && !item.needs_review) return false;
            if (
                !['ALL', 'REVIEW'].includes(this.importCustomerFilter)
                && item.status !== this.importCustomerFilter
            ) {
                return false;
            }
            if (!query) return true;
            const values = [
                item.name,
                item.id,
                item.source,
                ...(item.row_numbers || [])
            ];
            return values.some(value => String(value || '').toLowerCase().includes(query));
        });
    }

    public pagedImportCustomers() {
        const rows = this.filteredImportCustomers();
        const start = (this.importCustomerPage - 1) * this.importCustomerPageSize;
        return rows.slice(start, start + this.importCustomerPageSize);
    }

    public importCustomerPageCount() {
        return Math.max(
            1,
            Math.ceil(this.filteredImportCustomers().length / this.importCustomerPageSize)
        );
    }

    public async changeImportCustomerPage(direction: number) {
        this.importCustomerPage = Math.min(
            this.importCustomerPageCount(),
            Math.max(1, this.importCustomerPage + direction)
        );
        await this.service.render();
    }

    public async setStatusMappingFilter(filter: string) {
        this.statusMappingFilter = filter || 'ALL';
        this.statusMappingPage = 1;
        await this.service.render();
    }

    public async resetStatusMappingPage() {
        this.statusMappingPage = 1;
        await this.service.render();
    }

    public filteredStatusMappings() {
        const rows = this.importResult?.approvals?.status_mappings || [];
        const query = String(this.statusMappingSearch || '').trim().toLowerCase();
        return rows.filter((item: any) => {
            const canonical = String(item.canonical_status || item.recommended_status || '').toUpperCase();
            if (this.statusMappingFilter === 'PENDING' && item.approval_status === 'APPROVED') {
                return false;
            }
            if (this.statusMappingFilter === 'APPROVED' && item.approval_status !== 'APPROVED') {
                return false;
            }
            if (this.statusMappingFilter === 'UNKNOWN' && canonical !== 'UNKNOWN') {
                return false;
            }
            if (!query) return true;
            return [
                item.source_value,
                canonical,
                item.scope
            ].some(value => String(value || '').toLowerCase().includes(query));
        });
    }

    public pagedStatusMappings() {
        const rows = this.filteredStatusMappings();
        const start = (this.statusMappingPage - 1) * this.statusMappingPageSize;
        return rows.slice(start, start + this.statusMappingPageSize);
    }

    public statusMappingPageCount() {
        return Math.max(
            1,
            Math.ceil(this.filteredStatusMappings().length / this.statusMappingPageSize)
        );
    }

    public async changeStatusMappingPage(direction: number) {
        this.statusMappingPage = Math.min(
            this.statusMappingPageCount(),
            Math.max(1, this.statusMappingPage + direction)
        );
        await this.service.render();
    }

    public statusMappingCount(filter: string) {
        const rows = this.importResult?.approvals?.status_mappings || [];
        if (filter === 'PENDING') {
            return rows.filter((item: any) => item.approval_status !== 'APPROVED').length;
        }
        if (filter === 'APPROVED') {
            return rows.filter((item: any) => item.approval_status === 'APPROVED').length;
        }
        if (filter === 'UNKNOWN') {
            return rows.filter((item: any) => (
                String(item.canonical_status || item.recommended_status || '').toUpperCase()
                === 'UNKNOWN'
            )).length;
        }
        return rows.length;
    }

    public pendingApprovalCount() {
        const approvals = this.importResult?.approvals || {};
        const collections = [
            approvals.status_mappings || [],
            approvals.duplicate_items || [],
            approvals.our_ref_items || [],
            approvals.field_update_items || []
        ];
        return collections.reduce(
            (total: number, items: any[]) => total + items.filter(
                item => item.approval_status !== 'APPROVED'
            ).length,
            0
        );
    }

    public importCaseCategoryLabel(category: string) {
        const labels: any = {
            NEW: '신규 예정',
            EXISTING: '기존 사건',
            DUPLICATE: '중복 확인',
            ERROR: '처리 불가'
        };
        return labels[category] || category || '-';
    }

    public importCaseCategoryClass(category: string) {
        const classes: any = {
            NEW: 'bg-emerald-50 text-emerald-800 border-emerald-200',
            EXISTING: 'bg-blue-50 text-blue-800 border-blue-200',
            DUPLICATE: 'bg-violet-50 text-violet-800 border-violet-200',
            ERROR: 'bg-red-50 text-red-800 border-red-200'
        };
        return classes[category] || 'bg-slate-50 text-slate-700 border-slate-200';
    }

    public importCustomerStatusLabel(status: string) {
        return status === 'EXISTING' ? '기존 고객' : '신규 후보';
    }

    public importCustomerSourceLabel(source: string) {
        const labels: any = {
            CLIENT: '의뢰인',
            APPLICANT: '출원인 대체',
            MULTIPLE: '복합 출처'
        };
        return labels[source] || source || '-';
    }

    public rightTypeLabel(code: string) {
        const labels: any = {
            PATENT: '특허',
            UTILITY_MODEL: '실용신안',
            TRADEMARK: '상표',
            DESIGN: '디자인',
            OTHER: '기타'
        };
        return labels[code] || code || '-';
    }

    public canonicalStatusLabel(code: string) {
        const status = (this.importResult?.canonical_statuses || []).find(
            (item: any) => item.code === code
        );
        const fallbackLabels: any = {
            CLOSED: '종료',
            PENDING: '진행 예정',
            EXAMINATION: '심사 중',
            PUBLISHED: '공개',
            REGISTERED: '등록',
            REJECTED: '거절',
            WITHDRAWN: '취하',
            ABANDONED: '포기',
            EXPIRED: '소멸·만료',
            INVALIDATED: '무효',
            CANCELLED: '취소',
            UNKNOWN: '미정'
        };
        return status?.label || fallbackLabels[code] || code || '미정';
    }

    public statusScopeLabel(scope: string) {
        const labels: any = {
            TENANT: '우리 사무소 규칙',
            GLOBAL: '시스템 기본 규칙',
            SNAPSHOT: '실행 기준 고정',
            NONE: '저장된 규칙 없음'
        };
        return labels[scope] || labels.NONE;
    }

    public joinRowNumbers(values: any[]) {
        const rows = (values || []).map(value => `${value}행`);
        return rows.join(', ') || '-';
    }

    public isProtectedImport() {
        return this.importResult?.execution?.grant?.status === 'PROTECTED';
    }

    public blockerDescription(code: string) {
        const descriptions: any = {
            STATUS_MAPPING_UNAPPROVED: '엑셀 원문 상태가 시스템 상태로 어떻게 저장될지 아직 결정되지 않았습니다.',
            OURREF_AMBIGUOUS: '출원번호와 내부 관리번호가 서로 다른 사건을 가리켜 자동 연결을 멈췄습니다.',
            DUPLICATE_REPRESENTATIVE_UNSELECTED: '같은 출원번호가 여러 행에 있어 실제 반영할 대표행이 필요합니다.',
            FIELD_UPDATE_UNAPPROVED: '기존 데이터와 엑셀 값이 달라 어떤 값을 사용할지 결정해야 합니다.',
            EXECUTION_GRANT_REQUIRED: '모든 검토가 끝나면 플랫폼 이관 관리자가 5분 실행 권한을 발급합니다.',
            KONE_IMPORT_FORBIDDEN: '현재 사무소는 보호 대상이므로 이 화면에서는 실제 이관할 수 없습니다.'
        };
        return descriptions[code] || '실행 전에 이 항목을 확인해야 합니다.';
    }

    public rowLabel(item: any, rowId: string) {
        const index = (item?.row_ids || []).indexOf(rowId);
        return item?.source_rows?.[index] ? `${item.source_rows[index]}행` : rowId;
    }

    public importIssueGroups() {
        const issues = this.importResult?.analysis?.issues || [];
        const definitions = [
            {
                code: 'DECISION',
                step: '1',
                title: '지금 선택해 주세요',
                description: '아래에서 사용할 내용이나 저장할 상태를 하나씩 선택하면 됩니다.',
                class_name: 'border-amber-200 bg-amber-50'
            },
            {
                code: 'AUTO',
                step: '2',
                title: '시스템이 이렇게 처리했어요',
                description: '비어 있거나 여러 개인 값을 대신 정리했습니다. 결과가 맞는지만 확인해 주세요.',
                class_name: 'border-emerald-200 bg-emerald-50'
            },
            {
                code: 'FOLLOW_UP',
                step: '3',
                title: '이관 후 다시 확인해 주세요',
                description: '데이터는 옮길 수 있지만 담당 사용자 지정은 나중에 한 번 더 확인해야 합니다.',
                class_name: 'border-blue-200 bg-blue-50'
            }
        ];
        return definitions
            .map(group => ({
                ...group,
                items: issues.filter(
                    (issue: any) => this.importIssueGroupCode(issue.code) === group.code
                )
            }))
            .filter(group => group.items.length > 0);
    }

    public importIssueTitle(issue: any) {
        const titles: any = {
            FILE_DUPLICATE_APPLICATION_NO: '같은 출원번호가 두 번 들어있어요',
            STATUS_UNKNOWN: '사건 상태를 어떻게 저장할지 정해야 해요',
            CLIENT_FALLBACK_TO_APPLICANT: '의뢰인이 없어 출원인을 고객으로 사용했어요',
            TITLE_MISSING: '사건명이 없어 임시 이름을 만들어요',
            MULTIPLE_PARTIES: '한 칸에 여러 고객이 있어 각각 나눴어요',
            CASE_MANAGER_UNRESOLVED: '일치하는 담당자를 찾지 못했어요'
        };
        return titles[issue?.code] || issue?.title || '확인이 필요한 내용이 있어요';
    }

    public importIssueEffect(code: string) {
        const effects: any = {
            FILE_DUPLICATE_APPLICATION_NO: '두 내용 중 선택한 하나만 옮기고, 선택하지 않은 내용은 건너뜁니다.',
            STATUS_UNKNOWN: '엑셀에 적힌 상태 문구는 그대로 남기고, 선택한 시스템 상태로 저장합니다.',
            CLIENT_FALLBACK_TO_APPLICANT: '의뢰인 칸이 비어 있어 출원인 이름을 고객 후보로 사용했습니다.',
            TITLE_MISSING: '사건명 칸이 비어 있어 출원번호로 임시 사건명을 만듭니다.',
            MULTIPLE_PARTIES: '한 칸에 적힌 여러 이름을 각각의 고객 후보로 나눴습니다.',
            CASE_MANAGER_UNRESOLVED: '담당자 이름은 남기지만 실제 담당 사용자를 지정하지 않은 상태로 옮깁니다.'
        };
        return effects[code] || '엑셀의 원래 내용은 남겨두고 확인 결과에 따라 처리합니다.';
    }

    public importIssueAction(code: string) {
        if (code === 'FILE_DUPLICATE_APPLICATION_NO') {
            const pending = (this.importResult?.approvals?.duplicate_items || []).some(
                (item: any) => item.approval_status !== 'APPROVED'
            );
            return pending ? '아래에서 사용할 내용 선택' : '사용할 내용 선택 완료';
        }
        if (code === 'STATUS_UNKNOWN') {
            return this.statusMappingCount('PENDING') > 0
                ? '사건 상태 선택하기'
                : '사건 상태 선택 완료';
        }
        const actions: any = {
            CLIENT_FALLBACK_TO_APPLICANT: '고객 목록에서 확인',
            TITLE_MISSING: '이관 후 사건명 입력',
            MULTIPLE_PARTIES: '나뉜 고객 이름 확인',
            CASE_MANAGER_UNRESOLVED: '이관 후 담당자 지정'
        };
        return actions[code] || '엑셀 내용 확인';
    }

    public duplicateReviewRows(item: any) {
        const cases = this.importResult?.analysis?.cases || [];
        return (item?.row_ids || []).map((rowId: string, index: number) => {
            const rowNumber = Number(item?.source_rows?.[index] || 0);
            const caseRow = cases.find(
                (candidate: any) => Number(candidate.row_number || 0) === rowNumber
            ) || {};
            return {
                row_id: rowId,
                row_number: rowNumber,
                title: caseRow.title || '(명칭 없음)',
                application_no: caseRow.application_no || '',
                application_date: caseRow.application_date || '출원일 없음',
                customer_candidates: caseRow.customer_candidates || [],
                right_type: caseRow.right_type || ''
            };
        });
    }

    public duplicateApplicationNo(item: any) {
        return this.duplicateReviewRows(item)?.[0]?.application_no
            || item?.duplicate_key
            || '-';
    }

    private prepareApprovalDrafts() {
        const approvals = this.importResult?.approvals || {};
        for (const item of approvals.status_mappings || []) {
            item.draft_status = item.canonical_status || item.recommended_status || 'UNKNOWN';
        }
        for (const item of approvals.duplicate_items || []) {
            item.draft_representative_row_id = item.representative_row_id || item.row_ids?.[0] || '';
        }
        for (const item of approvals.field_update_items || []) {
            item.draft_action = item.action || 'KEEP_EXISTING';
        }
    }

    private importIssueGroupCode(code: string) {
        if ([
            'CLIENT_FALLBACK_TO_APPLICANT',
            'TITLE_MISSING',
            'MULTIPLE_PARTIES'
        ].includes(code)) {
            return 'AUTO';
        }
        if (code === 'CASE_MANAGER_UNRESOLVED') {
            return 'FOLLOW_UP';
        }
        return 'DECISION';
    }

    private async saveImportApproval(
        key: string,
        method: string,
        payload: any,
        successMessage: string
    ) {
        if (this.approvalSavingKey) return;
        this.approvalSavingKey = key;
        await this.service.render();
        const response: any = await wiz.call(method, {
            payload: JSON.stringify(payload || {})
        });
        const result = this.responsePayload(response);
        this.approvalSavingKey = '';
        if (Number(result.code) === 200) {
            await this.loadImportJob(this.importResult.job.id);
            await this.service.modal.success(successMessage);
        } else {
            await this.service.modal.error(this.responseMessage(result, '승인 저장에 실패했습니다.'));
        }
        await this.service.render();
    }

    public joinValues(values: any[]) {
        return (values || []).join(' / ') || '-';
    }

    public issueCodes(issues: any[]) {
        return (issues || []).map(issue => issue.code).join(', ') || '-';
    }

    private responsePayload(response: any) {
        return response?.responseJSON || response || {};
    }

    private responseMessage(payload: any, fallback: string) {
        if (typeof payload?.message === 'string' && payload.message) return payload.message;
        if (typeof payload?.data === 'string' && payload.data) return payload.data;
        if (typeof payload?.data?.message === 'string' && payload.data.message) return payload.data.message;
        return fallback;
    }
}

export default PageMypageComponent;